<template>
  <div>
    <van-nav-bar
      title="查找用户编号"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="body-div">
      <div class="title-div">获取燃气用户编号</div>
      <div class="text-div">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;燃气用户编号为11位数字，如果您的户号首位为“0”，
        <span class="text-span">请不要输入首位“0”。</span>
        您可以通过如下几种途径获知用户编号：
      </div>
      <div class="method-div">1.从各类单据上获取</div>
      <div class="method-div">（1）燃气卡</div>
      <img src="../../assets/accountNumberManagement/card2.png" width="100%" class="img-style">
      <div class="red-text">*红框部分为需要提交的用户编号</div>
      <div class="method-div">（2）购气凭证</div>
      <div class="voucher-div">IC卡购气凭证<br/>CPU卡购气凭证</div>
      <img src="../../assets/accountNumberManagement/card3.png" width="100%" class="img-style">
      <div class="voucher-img">
        <img src="../../assets/accountNumberManagement/card4.png" width="100%">
      </div>
      <div class="method-div">（3）缴费通知单</div>
      <img src="../../assets/accountNumberManagement/card5.png" width="100%" class="img-style">
      <div class="red-text">*红框部分为需要提交的用户编号</div>
      <div class="method-div">2.提报咨询单</div>
      <div class="consult-div">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如果找不到以上单据，您可拨打96777进行咨询，客服核实后会及时回复。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FindUserNumber',
  methods: {
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .body-div {
    padding: 0 4%;
  }

  .title-div {
    font-size: 19px;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 26px;
    color: #27282E;
    text-align: left;
  }

  .text-div {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 23px;
    color: #27282E;
    text-align: left;
    padding: 0 1%;
    margin-top: 12px;
  }

  .text-span {
    font-family: PingFangSC-Semibold;
    font-weight: bold;
  }

  .method-div {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 23px;
    color: #27282E;
    text-align: left;
    padding: 0 1%;
    margin-top: 12px;
  }

  .img-style {
    margin-top: 12px;
  }

  .red-text {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 19px;
    color: #CE0022;
    text-align: left;
  }

  .voucher-div {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 23px;
    color: #27282E;
    padding: 0 12%;
    margin-top: 12px;
  }

  .voucher-img {
    padding: 0 2%;
  }

  .consult-div {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 23px;
    color: #27282E;
    padding: 0 1% 35px 1%;
    margin-top: 12px;
  }
</style>
